import TYPES from './types';

const INITIAL_STATE = {
  blacklistedOrganizations: []
};

const reducer = (state = INITIAL_STATE, { type, payload }) => {
  switch (type) {
    case TYPES.GET_FUEL_VISIBILITY.SUCCESS:
      return {
        ...state,
        blacklistedOrganizations: payload.organization_ids
      };
    default:
      return state;
  }
};

export default reducer;
